import animation_lifecycle_controller from '../animations/lifecycle/animation_lifecycle_controller'

let anchorMenuItems = []
let anchorMenuListenersBound = false
let anchorMenuSnapScrollElements = []
let anchorMenuUpdateScheduled = false
let currentAnchorMenuHash = null
let anchorMenuClickTargetHash = null
let anchorMenuClickTargetUntil = 0

var emitAnchorMenuActiveStateChanged = function () {
	if (window.laytheme && typeof window.laytheme.emit === 'function') {
		window.laytheme.emit('current-menu-point-activated')
	}
}

var getAnchorMenuItemByHash = function (hash) {
	for (var i = 0; i < anchorMenuItems.length; i++) {
		if (anchorMenuItems[i].hash === hash) {
			return anchorMenuItems[i]
		}
	}
	return null
}

var startAnchorMenuClickTarget = function (hash) {
	anchorMenuClickTargetHash = hash
	anchorMenuClickTargetUntil = Date.now() + 2500
}

var shouldHoldAnchorMenuClickTarget = function () {
	if (!anchorMenuClickTargetHash) {
		return false
	}
	if (Date.now() > anchorMenuClickTargetUntil) {
		anchorMenuClickTargetHash = null
		return false
	}

	var item = getAnchorMenuItemByHash(anchorMenuClickTargetHash)
	var target = getCurrentAnchorTarget(item)
	if (!item || !target) {
		anchorMenuClickTargetHash = null
		return false
	}

	var rect = target.getBoundingClientRect()
	if (Math.abs(rect.top) <= 4) {
		anchorMenuClickTargetHash = null
		return false
	}

	return true
}

var activateAnchorMenuFromLink = function ($link) {
	var hash = extractHashFromHref($link.attr('href'))
	if (!hash || !isAnchorLinkToSamePage($link)) {
		return
	}
	collectAnchorMenuItems()
	startAnchorMenuClickTarget(hash)
	activateAnchorMenuHash(hash, true)
}

var unbindAnchorMenuSnapScrollTargets = function () {
	anchorMenuSnapScrollElements.forEach(function (el) {
		jQuery(el).off('scroll.anchorMenu')
	})
	anchorMenuSnapScrollElements = []
}

/**
 * Fullscreen / magnetic slides vertical scroll uses overflow on .vertical-scrollsnap (not window).
 * Horizontal snap scrolls .horizontal-scrollsnap > .grid-inner. Without these listeners anchor
 * highlighting never updates while snapping between rows.
 */
var bindAnchorMenuSnapScrollTargets = function () {
	unbindAnchorMenuSnapScrollTargets()
	jQuery('.vertical-scrollsnap').each(function () {
		jQuery(this).on('scroll.anchorMenu', scheduleAnchorMenuUpdate)
		anchorMenuSnapScrollElements.push(this)
	})
	jQuery('.horizontal-scrollsnap > .grid-inner').each(function () {
		jQuery(this).on('scroll.anchorMenu', scheduleAnchorMenuUpdate)
		anchorMenuSnapScrollElements.push(this)
	})
}

var refreshAnchorMenuAfterPageShown = function () {
	collectAnchorMenuItems()
	bindAnchorMenuSnapScrollTargets()
	updateAnchorMenuActiveState(true)
}

var initAnchorMenuHighlighting = function () {
	// Check if anchor menu active highlighting is enabled
	if (typeof layData === 'undefined' || layData.anchor_menu_active !== 'on') {
		return
	}

	collectAnchorMenuItems()

	if (!anchorMenuListenersBound) {
		anchorMenuListenersBound = true

		jQuery(window).on('scroll.anchorMenu resize.anchorMenu', scheduleAnchorMenuUpdate)

		if (typeof window !== 'undefined' && window.eventsChannel && typeof window.eventsChannel.on === 'function') {
			window.eventsChannel.on('scroll', function () {
				scheduleAnchorMenuUpdate()
			})
		}

		jQuery(window).on('fpAfterLoad fpAfterSlideLoad fpAfterRender', function () {
			setTimeout(function () {
				bindAnchorMenuSnapScrollTargets()
				updateAnchorMenuActiveState(true)
			}, 0)
		})

		// Re-enable anchor menu updates after transition completes
		window.laytheme.on('transition_navigation_in_completed', function () {
			setTimeout(function () {
				bindAnchorMenuSnapScrollTargets()
				updateAnchorMenuActiveState(true)
			}, 100)
		})

		// Scroll-snap init runs after our first pass; refresh bindings when grid is ready
		window.laytheme.on('newpageshown', function () {
			setTimeout(refreshAnchorMenuAfterPageShown, 0)
			setTimeout(refreshAnchorMenuAfterPageShown, 150)
		})

		jQuery(document).on('pointerdown.anchorMenu mousedown.anchorMenu touchstart.anchorMenu', 'nav a[href*="#"]', function (event) {
			var originalEvent = event.originalEvent || event
			if (originalEvent && originalEvent.type === 'mousedown' && originalEvent.button !== 0) {
				return
			}
			activateAnchorMenuFromLink(jQuery(this))
		})

		jQuery(document).on('click.anchorMenu', 'nav a[href*="#"]', function () {
			activateAnchorMenuFromLink(jQuery(this))
		})
	}

	bindAnchorMenuSnapScrollTargets()

	if (anchorMenuItems.length === 0) {
		return
	}

	setTimeout(function () {
		bindAnchorMenuSnapScrollTargets()
		updateAnchorMenuActiveState(true)
	}, 100)
}

var collectAnchorMenuItems = function () {
	anchorMenuItems = []

	var $navLinks = jQuery('nav a[href*="#"]')
	if ($navLinks.length === 0) {
		return
	}

	$navLinks.each(function () {
		var $link = jQuery(this)
		var href = $link.attr('href')
		if (!href) {
			return
		}

		var hash = extractHashFromHref(href)
		if (!hash) {
			return
		}

		if (!isAnchorLinkToSamePage($link)) {
			return
		}

		var targetInfos = findAnchorTargets(hash)
		if (targetInfos.length === 0) {
			return
		}

		var li = $link.closest('li.menu-item')
		if (li.length === 0) {
			return
		}

		li.addClass('lay-anchor-menu-item')

		anchorMenuItems.push({
			hash: hash,
			link: $link,
			li: li,
			target: targetInfos[0],
			targets: targetInfos,
		})
	})
}

var extractHashFromHref = function (href) {
	var hashIndex = href.indexOf('#')
	if (hashIndex === -1) {
		return null
	}
	var hash = href.substring(hashIndex)
	if (!hash || hash === '#') {
		return null
	}

	if (hash.indexOf('?') !== -1) {
		hash = hash.substring(0, hash.indexOf('?'))
	}
	if (hash.indexOf('&') !== -1 || hash.indexOf('=') !== -1) {
		return null
	}

	return decodeURIComponent(hash)
}

var isAnchorLinkToSamePage = function ($anchor) {
	var href = $anchor.attr('href')
	if (!href || href.indexOf('#') === -1) {
		return false
	}

	if (href.substr(0, 1) === '#') {
		return true
	}

	if ($anchor[0].hasAttribute('data-id') && $anchor[0].hasAttribute('data-type')) {
		if ($anchor.attr('data-id') == jQuery('body').attr('data-id') && $anchor.attr('data-type') == jQuery('body').attr('data-type')) {
			return true
		}
	}

	var currentLocation = window.location.href.split('#')[0]
	var linkBase = href.split('#')[0]

	var normalize = function (url) {
		if (!url) {
			return ''
		}
		if (url.substr(url.length - 1) === '/') {
			return url.substr(0, url.length - 1)
		}
		return url
	}

	return normalize(linkBase) === normalize(currentLocation)
}

var normalizeAnchorTarget = function (target) {
	if (!target) {
		return null
	}

	var $row = jQuery(target).closest('.row')
	if ($row.length > 0) {
		return $row[0]
	}

	return target
}

var addAnchorTarget = function (targets, target) {
	target = normalizeAnchorTarget(target)
	if (!target) {
		return
	}
	if (targets.indexOf(target) === -1) {
		targets.push(target)
	}
}

var findAnchorTargets = function (hash) {
	var id = hash.substring(1)
	if (!id) {
		return []
	}

	var targets = []

	jQuery('[id]').each(function () {
		if (this.id === id) {
			addAnchorTarget(targets, this)
		}
	})

	var named = document.getElementsByName(id)
	if (named && named.length > 0) {
		for (var i = 0; i < named.length; i++) {
			addAnchorTarget(targets, named[i])
		}
	}

	return targets
}

var getCurrentAnchorTarget = function (item) {
	if (!item) {
		return null
	}

	var targets = item.targets && item.targets.length ? item.targets : [item.target]
	for (var i = 0; i < targets.length; i++) {
		var target = targets[i]
		if (!target || target.offsetParent === null) {
			continue
		}
		var rect = target.getBoundingClientRect()
		if (rect.width === 0 && rect.height === 0) {
			continue
		}
		return target
	}

	return null
}

var scheduleAnchorMenuUpdate = function () {
	// Don't update during page transitions
	if (animation_lifecycle_controller.isNavigationAnimating()) {
		return
	}

	if (anchorMenuUpdateScheduled) {
		return
	}
	anchorMenuUpdateScheduled = true
	window.requestAnimationFrame(function () {
		anchorMenuUpdateScheduled = false
		updateAnchorMenuActiveState(false)
	})
}

var updateAnchorMenuActiveState = function (force) {
	if (anchorMenuItems.length === 0) {
		return
	}

	// Don't update during page transitions unless forced
	if (!force) {
		if (animation_lifecycle_controller.isNavigationAnimating()) {
			return
		}
	}

	if (!force && shouldHoldAnchorMenuClickTarget()) {
		if (currentAnchorMenuHash !== anchorMenuClickTargetHash) {
			activateAnchorMenuHash(anchorMenuClickTargetHash, false)
		}
		return
	}

	var hash = determineCurrentAnchorHash()

	// If hash is null and we have a current hash, we need to remove active class
	// If hash is null and we don't have a current hash, no update needed (unless forced)
	if (!hash && !currentAnchorMenuHash && !force) {
		return
	}

	// If hash hasn't changed, no update needed (unless forced)
	if (hash === currentAnchorMenuHash && !force) {
		return
	}

	activateAnchorMenuHash(hash, force)
}

var activateAnchorMenuHash = function (hash, force) {
	if (hash === currentAnchorMenuHash && !force) {
		return
	}

	currentAnchorMenuHash = hash

	anchorMenuItems.forEach((item) => {
		if (!item.li || item.li.length === 0) {
			return
		}
		if (hash && item.hash === hash) {
			item.li.addClass('current-menu-item')
		} else {
			item.li.removeClass('current-menu-item')
		}
	})

	emitAnchorMenuActiveStateChanged()
}

var determineCurrentAnchorHash = function () {
	if (anchorMenuItems.length === 0) {
		return null
	}

	var viewportReference = window.innerHeight * 0.3
	var viewportH = window.innerHeight
	// For browser-height / scroll-snap rows: only treat as active once the row top has passed
	// the upper half of the viewport, so spacer rows without IDs do not hand off "active" too early.
	var tallRowTopGate = viewportH * 0.5

	var targetIsTallRow = function (el) {
		if (!el || !el.classList) {
			return false
		}
		if (el.classList.contains('_100vh')) {
			return true
		}
		if (el.classList.contains('row')) {
			var rh = el.getBoundingClientRect().height
			return rh >= viewportH * 0.72
		}
		return false
	}

	var passesTallRowGate = function (target, rect) {
		if (!targetIsTallRow(target)) {
			return true
		}
		return rect.top <= tallRowTopGate
	}

	var keepActiveUntilNextAnchor = typeof layData !== 'undefined' && layData.anchor_menu_keep_active_until_next === 'on'
	var bestItem = null
	var bestDistance = Number.POSITIVE_INFINITY
	var bestPassedItem = null
	var bestPassedTarget = null
	var bestFallbackItem = null
	var bestFallbackDistance = Number.POSITIVE_INFINITY

	var targetComesAfter = function (candidate, current) {
		if (!candidate || !current || candidate === current || typeof current.compareDocumentPosition !== 'function') {
			return false
		}
		// DOCUMENT_POSITION_FOLLOWING = 4. Use document order instead of
		// rect.top: anchors inside a sticky cover keep a fixed visual top and
		// would otherwise become active again after a later anchor scrolls past.
		return (current.compareDocumentPosition(candidate) & 4) !== 0
	}

	for (var i = 0; i < anchorMenuItems.length; i++) {
		var item = anchorMenuItems[i]
		var target = getCurrentAnchorTarget(item)
		if (!target) {
			continue
		}
		var rect = target.getBoundingClientRect()
		if (rect.width === 0 && rect.height === 0) {
			continue
		}

		// Check if element is visible in viewport
		var isVisible = rect.top < window.innerHeight && rect.bottom > 0
		if (!isVisible && (!keepActiveUntilNextAnchor || rect.top > viewportH)) {
			continue
		}

		if (!passesTallRowGate(target, rect)) {
			continue
		}

		if (keepActiveUntilNextAnchor) {
			if (rect.top <= viewportReference) {
				if (!bestPassedItem || targetComesAfter(target, bestPassedTarget)) {
					bestPassedItem = item
					bestPassedTarget = target
				}
				continue
			}

			var fallbackDistance = Math.abs(rect.top - viewportReference)
			if (isVisible && fallbackDistance < bestFallbackDistance) {
				bestFallbackDistance = fallbackDistance
				bestFallbackItem = item
			}
			continue
		}

		if (rect.top <= viewportReference && rect.bottom > viewportReference) {
			bestItem = item
			break
		}

		var distance = Math.abs(rect.top - viewportReference)
		if (distance < bestDistance) {
			bestDistance = distance
			bestItem = item
		}
	}

	if (keepActiveUntilNextAnchor) {
		bestItem = bestPassedItem || bestFallbackItem
	}

	return bestItem ? bestItem.hash : null
}

export { initAnchorMenuHighlighting }
